import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { UntypedFormArray, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { ReplaySubject, Subscription } from 'rxjs';
import { DynamicOptionsComponent } from '../dynamic-options';

@Component({
  template: '',
  standalone: true,
})
export class LifecycleOptionsComponent implements OnInit, OnDestroy, DynamicOptionsComponent {
  @Input() set initialValue(val: number) {
    this.initialValue$$.next(val);
  }

  initialValue$$ = new ReplaySubject<number>(1);
  initialValue$ = this.initialValue$$.asObservable();

  lifecycleOptionControl: UntypedFormControl = new UntypedFormControl(null);

  selectedValue$ = this.lifecycleOptionControl.valueChanges;

  subscriptions = new Subscription();

  ngOnInit(): void {
    this.subscriptions.add(
      this.initialValue$.subscribe((i) => {
        this.lifecycleOptionControl.setValue(i);
      }),
    );
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  getControlsToValidateOnSave(): (UntypedFormControl | UntypedFormGroup | UntypedFormArray)[] {
    return [this.lifecycleOptionControl];
  }

  getSelectedValue(): number {
    return this.lifecycleOptionControl?.value;
  }

  isFormValid(): boolean {
    return this.lifecycleOptionControl.valid;
  }
}
